import { setCopyCoordsButtonIsClicked, setSearchLineIsShown } from "../../../../stateManagement/reducers/ContentHeaderSlice"
import { store } from "../../../../stateManagement/store"

export function controlNavigateToMapButton(navigate: any) {
    navigate('/app/map/AllRoadObjects')
}

export function controlMapSettingsButton(navigate: any) {
    navigate('/app/mapSettings/panorama')
}

export function controlCopyCoordsButton() {
    const copyCoordsButtonIsClicked = store.getState().contentHeader.copyCoordsButtonIsClicked
    store.dispatch(setCopyCoordsButtonIsClicked(!copyCoordsButtonIsClicked))
}

export function controlSearchLineButton() {
    const searchLineIsShown = store.getState().contentHeader.searchLineIsShown
    store.dispatch(setSearchLineIsShown(!searchLineIsShown))
}

export function controlPanoramaFilterButton(navigate: any) {
    navigate('/app/panoramaFilters')
}